module.exports = __webpack_public_path__ + "static/media/9DESA23.9e0d96d9.jpg";